"use client";

import MainBarSearch from "modules/common/components/mainbar/MainBarSearch";
import { SortControls } from "modules/common/components/mainbar/SortControls";
import { InlineSearch } from "modules/common/components/navigation/InlineSearch";
import { SetMobileMainbar } from "modules/sets/components/mobile/SetMobileMainbar";
import { useSetFilters } from "modules/sets/hooks/useSetFilters";
import { SET_SORT_OPTIONS } from "modules/sets/constants/sortOptions";
import type { GameId } from "modules/common/model/models";

function SearchSection({
  onQueryChange,
  searchInput,
  game,
}: {
  onQueryChange: (query: string) => void;
  searchInput: string;
  game?: GameId;
}) {
  return (
    <div className="flex w-full flex-col gap-2 self-start justify-self-start md:mr-auto md:w-fit md:flex-row">
      <InlineSearch
        game={game}
        className={"hidden w-full max-w-2xl md:flex md:w-1/2"}
      />
      <MainBarSearch
        placeholder="Search for a set"
        onQueryChange={onQueryChange}
        initialQuery={searchInput}
        className="w-full max-w-2xl md:w-fit"
      />
    </div>
  );
}

interface SetMainbarProps {
  game: GameId;
}

export function SetMainbar({ game }: SetMainbarProps) {
  const {
    filters: setsReq,
    setNameDebounced,
    setSort,
    setOrder,
  } = useSetFilters();

  return (
    <>
      <div className="w-full md:hidden">
        <SetMobileMainbar />
      </div>

      <div className="hidden w-full md:block">
        <div className="flex flex-col gap-2 px-1 md:flex-row md:items-center md:justify-end">
          <SearchSection
            onQueryChange={setNameDebounced}
            searchInput={setsReq.query}
            game={game}
          />

          <SortControls
            options={SET_SORT_OPTIONS}
            currentSort={setsReq.sort}
            currentOrder={setsReq.order}
            onSortChange={setSort}
            onOrderChange={setOrder}
          />
        </div>
      </div>
    </>
  );
}
